export const fanhui = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 13.5L7.176 8L13 2.5L11.412 1L4 8L11.412 15L13 13.5Z" fill="#1F1F1F"/>
</svg>
